import React, { useState } from "react";
import TextBox, { Button } from "devextreme-react/text-box";

// const ICON_EYE = '/assets/svg/icons/eye-regular.svg';
// const ICON_EYE_SLASH = '/assets/svg/icons/eye-slash-regular.svg';

export default React.forwardRef(({placeholder,value, defaultValue, readOnly, onValueChanged,
    displayButton, children, onKeyDown}, ref) => {
    const [mode, setMode] = useState('passwd');

    const toggleMode = () => {
        if (mode === 'passwd') {
            setMode('no-passwd');
        } else {
            setMode('passwd');
        }
    };

   // console.log(['Render Password'])
    return (
        <TextBox placeholder={placeholder}
                 ref={ref}
                 mode="text"
                 readOnly={readOnly}
                 defaultValue={defaultValue}
                 //value={value}
                 autoComplete="off"
                 onFocusIn={e=> {
                     if (e.event && typeof e.event.target === "function") {
                         e.event.target.select()
                     }
                 }} // parola metnini seçili yap
                 inputAttr={{class:mode}}
                 onKeyDown={onKeyDown}
                 valueChangeEvent="keyup blur"
                 onValueChanged={onValueChanged}
                 stylingMode={'filled'}>
            { displayButton &&
                <Button location="after"
                        name="passwd"
                        options={{
                            // icon: mode === 'passwd' ? ICON_EYE_SLASH : ICON_EYE ,
                            icon: mode === 'passwd' ? 'fa fa-eye-slash' : 'fa fa-eye',
                            type: 'normal', stylingMode: 'text',
                            //  class: 'mode',
                            elementAttr: {'class' : mode},
                            //text:'',
                            //template: renderButton,
                            onClick: toggleMode
                        }}/>

            }
            {children}
        </TextBox>
    );
});